import styled from "styled-components";
import { SIDEBAR } from "../../../constants";
export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid
    var(--sinch-comp-card-color-white-default-border-initial);
  min-height: ${SIDEBAR.mobileHeight}px;
`;

export const StyledTitle = styled.h1`
  color: var(--sinch-comp-select-button-color-default-icon-initial);
  margin: 0;
`;
